var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"cloud-upload",attrs:{"action":"","accept":_vm.config.accept,"http-request":_vm.fileUpload,"show-file-list":false,"multiple":_vm.config.multiple}},[_vm._t("choose")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355a5e1d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/cloudUpload/src/index.vue
// module id = 328
// module chunks = 0